/**
 *
 * @author Matthew Rawson @ 14/02/2018 13:48
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Grid} from "react-bootstrap"
import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {hangPromise} from "@irati/utils/promise"
import authentication from "@irati/auth"
import {HasPermissionTo} from "@irati/utils/permissions"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import SchedulesQuery from "@irati/insights/apollo/query/schedule/list"
import SchedulesCountQuery from "@irati/insights/apollo/query/schedule/count"
import Button, {IconTextButton} from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"
import {perkbox} from "@irati/ui/src/global/colors"
import Loader from "@irati/ui/src/Loading/Loader"

import {CreateScheduleButton, DemoCycleList} from "../../components/Schedule"
import {Breadcrumbs} from "../../components/Navigation"
import {CycleList} from "../../components/Schedule/CycleList"
import {Page} from "../../components/Layout"
import sitemap from "../sitemap"
import DropDown from "../../components/Home/DropDown"
import FlexWrapper from "../../ui/Layout/FlexWrapper"

const PAGE_SIZE = 10


const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledButton = styled(IconTextButton)`
  margin-right: ${padding.base};
  margin-bottom: ${padding.base};
  border-radius: 0;
  padding: 0 0 10px;
  ${({isActive}) => isActive && `
    box-shadow: 0 4px 0 0 ${perkbox.blue};
  `}
`

const SpacedContent = styled.div`
  padding-right: 5px;
`

const LoadingButtonWrapper = styled.div`
 display: flex;
 justify-content: center;
 align-items: center;
 margin-top: ${padding.base};
`

class Homepage extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired
  }
  static defaultProps = {}


  constructor(props) {
    super(props)
    this.state = {
      load: hangPromise(),
      statusFilter: null
    }
  }

  handleClick = (statusFilter, {currentTarget}) => {
    if (currentTarget) currentTarget.blur()
    this.setState({
      statusFilter
    })
  }


  render() {
    const idNamespace = id("schedule-list", this.props, {force: true})
    const {statusFilter} = this.state
    const defaultParams = {
      tenant: authentication.userTenant().uuid,
      orderBy: "createdAt",
      orderDirection: "DESC",
      withInterest: true,
      limit: PAGE_SIZE
    }

    return (
      <Grid>
        <HasPermissionTo permissions="insights.survey">
          <Page id={idNamespace}>
            <Heading>
              <Breadcrumbs id={idNamespace} crumbs={[sitemap.homepage]} />
              <FlexWrapper>
                <HasPermissionTo
                  permissions="insights.wizard"
                  Error={(
                    <CreateScheduleButton primary id={idNamespace}>
                      <FormattedMessage id="insights.cycleList.createNewSurvey" />
                    </CreateScheduleButton>
                  )}>
                  <ButtonRouterLink to={sitemap.wizardStep1.url} primary id={idNamespace}>
                    <FormattedMessage id="insights.cycleList.createNewSurvey" />
                  </ButtonRouterLink>
                </HasPermissionTo>

                <HasPermissionTo permissions="insights.reports" Error={null}>
                  <DropDown id={idNamespace} />
                </HasPermissionTo>
              </FlexWrapper>

            </Heading>
            <SchedulesCountQuery variables={{...defaultParams, status: null}} fetchPolicy="network-only" Loader={() => null}>
              {({data: {active, archived}, refetch: refetchTotals}) => (
                <div>
                  <FlexWrapper>
                    <StyledButton onClick={(e) => this.handleClick(null, e)} icon="mySurveys" isActive={!statusFilter}>
                      <FlexWrapper>
                        <SpacedContent>
                          <FormattedMessage id="insights.homepage.cycleList" />
                        </SpacedContent>&nbsp;({active.total})
                      </FlexWrapper>
                    </StyledButton>
                    <StyledButton onClick={(e) => this.handleClick("archived", e)} icon="archive" isActive={statusFilter}>
                      <FlexWrapper>
                        <SpacedContent>
                          <FormattedMessage id="insights.homepage.archiveList" />
                        </SpacedContent>&nbsp;({archived.total})
                      </FlexWrapper>
                    </StyledButton>
                  </FlexWrapper>
                  <div>
                    <SchedulesQuery
                      notifyOnNetworkStatusChange
                      useLoader={false}
                      variables={{...defaultParams, status: statusFilter, withLatestSurvey: !statusFilter}}
                      fetchPolicy="network-only">
                      {({data: {results, total}, refetch: refetchList, fetchMore, loading, networkStatus}) => {
                        const loadMore = () => {
                          return fetchMore({
                            variables: {
                              offset: results.length
                            },
                            updateQuery: (prev, {fetchMoreResult}) => {
                              if (!fetchMoreResult) return prev
                              const {schedules} = fetchMoreResult
                              return {
                                schedules: {
                                  ...schedules,
                                  results: [...prev.schedules.results, ...schedules.results]
                                }
                              }
                            }
                          })
                        }
                        if (loading && networkStatus !== 3) return <Loader />
                        return (
                         <>
                           <CycleList
                             id={idNamespace}
                             cycleList={results}
                             onChange={() => {
                               refetchList()
                               refetchTotals()
                             }} />
                           {results.length < total && (
                             <LoadingButtonWrapper>
                               <Button large apolloState={{loading}} onClick={loadMore}>
                                 <FormattedMessage id="insights.homepage.loadMore" />
                               </Button>
                             </LoadingButtonWrapper>
                           ) }
                         </>
                        )
                      }}
                    </SchedulesQuery>
                    {!statusFilter && <DemoCycleList />}
                  </div>
                </div>
              )}
            </SchedulesCountQuery>
          </Page>
        </HasPermissionTo>
      </Grid>
    )
  }
}

export default Homepage
